var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("table", {}, [
    _c(
      "tbody",
      _vm._l(_vm.item, function (item, idx) {
        return _c("tr", { key: `item-${_vm.id}-${idx}` }, [
          item.name
            ? _c("td", [
                _vm._v(
                  "\n                " + _vm._s(item.name) + "\n            "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "td",
            [
              item.value
                ? [
                    _vm.isPrimitive(item.value)
                      ? [_c("primitive-element", { attrs: { item: item } })]
                      : _vm.isArray(item.value)
                      ? _vm._l(item.value, function (child, idxChild) {
                          return _c(
                            "p",
                            {
                              key: `item-child-${_vm.id}-${idxChild}`,
                              staticClass: "mb-0",
                            },
                            [
                              _vm.isObject(child)
                                ? [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(_vm.resolvePath(child, "name")) +
                                        "\n                            "
                                    ),
                                  ]
                                : _vm.isPrimitive(child)
                                ? [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(child) +
                                        "\n                            "
                                    ),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          )
                        })
                      : _vm._e(),
                  ]
                : _vm.isArray(item)
                ? [
                    _c("group-element", {
                      attrs: { id: `child-${_vm.id}`, item: item },
                    }),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ])
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }